import actionType from 'utils/mw/actionType.util';

// special utility actions begin
export const INERT = actionType('InertAction');
export const MISSING = actionType('MissingAction');
// special utility actions end

export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE';

export const aTypeFetchEventsBySalon = actionType('fetchEventsBySalon');
export const aTypeFetchProceduresBySalon = actionType('fetchProceduresBySalon');
export const aTypeCreateUpdateTimeoff = actionType('createUpdateTimeoff');
export const aTypeUpdateProcedure = actionType('updateProcedure');
export const aTypeUndoProcedure = actionType('undoProcedure');
export const aTypeGetProcedureLog = actionType('getProcedureLog');

// rebook types begin
export const aTypeRebookPreload = actionType('rebookPreload');
export const aTypeRebook = actionType('rebook');
// rebook types end

// activity types begin
export const aTypeMarkActivityFeedItemAsSeen = actionType('markActivityFeedItemAsSeen');
export const aTypeMarkActivityFeedItemAsSeenAtMutu = actionType('markActivityFeedItemAsSeenAtMutu');
export const aTypeMarkActivityFeedItemAsNotSeen = actionType('markActivityFeedItemAsNotSeen');
export const aTypeMarkActivityFeedItemAsUseful = actionType('markActivityFeedItemAsUseful');
export const aTypeMarkActivityFeedItemAsNotUseful = actionType('markActivityFeedItemAsNotUseful');
export const aTypeUpdateActivityFeed = actionType('updateActivityFeed');
export const aTypeMutuCallNumber = actionType('mutuCallNumber');
export const aTypeGetClientActivityFeed = actionType('getClientActivityFeed');
// activity types end

// appointment types begin
export const aTypeMarkAppointmentEdit = actionType('markAppointmentEdit');
// appointment types end

// checkout types begin
export const aTypeInitCheckoutData = actionType('feInitCheckoutData'); // old 'SET_CHECKOUT_INIT_DATA'
// checkout types end
